"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _components = require("../../../../../common/components");

var _Addon = _interopRequireDefault(require("./Addon"));

var _TrafficListItemHeader = _interopRequireDefault(require("./TrafficListItemHeader"));

var _TrafficListItemDueDate = _interopRequireDefault(require("./TrafficListItemDueDate"));

var _utils = require("../../../../../common/utils");

var _colors = require("../../../../../common/styles/colors");

var _statusMap = _interopRequireDefault(require("../../../constants/statusMap"));

require("../styles/traffic-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RUSH_EDIT_ICONS = {
  RUSH_EDIT: 'rushedit',
  SUPER_RUSH_EDIT: 'rushsuper'
};

var TrafficListItem = /*#__PURE__*/function (_Component) {
  _inherits(TrafficListItem, _Component);

  var _super = _createSuper(TrafficListItem);

  function TrafficListItem() {
    var _this;

    _classCallCheck(this, TrafficListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getEditorOption", (0, _lodash.default)(function (editor) {
      if (!editor) {
        return null;
      }

      var userId = editor.userId,
          firstName = editor.firstName,
          lastName = editor.lastName,
          imageUrl = editor.imageUrl;
      return {
        label: (0, _getUserFullName.default)({
          firstName: firstName,
          lastName: lastName
        }),
        value: userId,
        prefix: /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
          imageUrl: imageUrl,
          placeholderText: (0, _getUserFullName.default)({
            firstName: firstName,
            lastName: lastName
          }),
          placeholderTextSize: 12,
          height: "25px",
          width: "25px",
          circular: true
        })
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "getCurrentVersion", function (versions) {
      return versions.reduce(function (prev, current) {
        return current.versionNumber > prev.versionNumber ? current : prev;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getStatusDiplayString", function (_ref) {
      var status = _ref.status,
          submittedAt = _ref.submittedAt;

      if (_statusMap.default[status.name]) {
        return status.name;
      }

      if (status.name === 'COST_REVIEW' && submittedAt) {
        return 'PENDING_REVIEW';
      }

      return 'DRAFT';
    });

    _defineProperty(_assertThisInitialized(_this), "renderTags", function (status, submittedAt, atRisk, latestVersion) {
      var statusName = _this.getStatusDiplayString({
        status: status,
        submittedAt: submittedAt
      });

      var tags = [].concat(_toConsumableArray(atRisk ? [{
        name: '!!!',
        color: _vars.COLOURS.red.redApple
      }] : []), [{
        name: _statusMap.default[statusName],
        color: _colors.STATUS_COLORS_MAP[statusName]
      }, {
        name: "V".concat(latestVersion),
        color: _colors.STATUS_COLORS_MAP[statusName]
      }]);
      return tags.map(function (_ref2) {
        var tagName = _ref2.name,
            color = _ref2.color;
        return /*#__PURE__*/_react.default.createElement("div", {
          key: tagName,
          style: {
            background: color
          },
          className: "list-item__header__tag"
        }, tagName);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditorChange", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var value, _this$props, outputId, updateOutput;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = _ref3.value;
                _this$props = _this.props, outputId = _this$props.output.outputId, updateOutput = _this$props.updateOutput;
                _context.next = 4;
                return updateOutput({
                  outputId: outputId,
                  input: {
                    assignedEditorId: value
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleDifficultyChange", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5) {
        var value, _this$props2, outputId, updateOutput;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                value = _ref5.value;
                _this$props2 = _this.props, outputId = _this$props2.output.outputId, updateOutput = _this$props2.updateOutput;
                _context2.next = 4;
                return updateOutput({
                  outputId: outputId,
                  input: {
                    difficulty: value
                  }
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderAddons", function (appliedAddons) {
      var _this$props3 = _this.props,
          getCaptions = _this$props3.getCaptions,
          getFormattedAddon = _this$props3.getFormattedAddon;
      var captions = getCaptions(appliedAddons);
      var formattedAddons = Object.keys(appliedAddons).map(function (key) {
        return getFormattedAddon(key, appliedAddons);
      }).filter(Boolean);

      if (!captions.length && !formattedAddons.length) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "list-item__addons"
      }, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading4: true,
        className: "list-item__addons__header"
      }, "Add-ons"), /*#__PURE__*/_react.default.createElement("div", {
        className: "list-item__addons__list"
      }, formattedAddons.map(function (_ref7) {
        var icon = _ref7.icon,
            reviewLabel = _ref7.reviewLabel,
            label = _ref7.label;
        return /*#__PURE__*/_react.default.createElement(_Addon.default, {
          key: reviewLabel || label,
          icon: icon,
          label: reviewLabel || label
        });
      }), captions.map(function (_ref8) {
        var captionValue = _ref8.captionValue,
            type = _ref8.type;
        return /*#__PURE__*/_react.default.createElement(_Addon.default, {
          key: "".concat(captionValue.label, "(").concat(type, ")"),
          icon: captionValue.prefix,
          label: "".concat(captionValue.label, "(").concat(type, ")")
        });
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "stopPropagation", function (event) {
      event.stopPropagation();
    });

    return _this;
  }

  _createClass(TrafficListItem, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          output = _this$props4.output,
          editors = _this$props4.editors,
          gotoVideo = _this$props4.gotoVideo,
          popupActions = _this$props4.popupActions;

      if (!output) {
        return null;
      }

      var video = output.video,
          status = output.status,
          difficulty = output.difficulty,
          editor = output.editor,
          versions = output.versions,
          onHoldDate = output.onHoldDate,
          readableId = output.readableId;
      var name = video.name,
          organisation = video.organisation,
          owner = video.owner,
          submittedAt = video.submittedAt;

      var _this$getCurrentVersi = this.getCurrentVersion(versions),
          appliedAddons = _this$getCurrentVersi.appliedAddons,
          dueDate = _this$getCurrentVersi.dueDate,
          assetId = _this$getCurrentVersi.assetId,
          versionNumber = _this$getCurrentVersi.versionNumber;

      var RUSH_EDIT = appliedAddons.RUSH_EDIT;
      var rushEditIconName = RUSH_EDIT && RUSH_EDIT_ICONS[RUSH_EDIT.value];

      var _getTimeRemaining = (0, _utils.getTimeRemaining)({
        dueDate: dueDate,
        RUSH_EDIT: RUSH_EDIT,
        onHoldDate: onHoldDate
      }),
          hoursLeft = _getTimeRemaining.hoursLeft,
          percentageComplete = _getTimeRemaining.percentageComplete;

      var isDraft = status.name === 'DRAFT';
      var videoName = "[".concat(readableId, "] ").concat(name);
      return /*#__PURE__*/_react.default.createElement(_uiKit.List.ListItem, {
        defaultImageIcon: "video",
        hideImage: true,
        onClick: gotoVideo
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "list-item__header"
      }, this.renderTags(status, submittedAt, organisation && organisation.atRisk, versionNumber), /*#__PURE__*/_react.default.createElement("div", {
        className: "list-item__header__time"
      }, rushEditIconName ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: rushEditIconName,
        size: 30
      }) : null, /*#__PURE__*/_react.default.createElement(_TrafficListItemHeader.default, {
        dueDate: dueDate,
        hoursLeft: hoursLeft,
        percentageComplete: percentageComplete,
        outputStatus: status.name
      }), /*#__PURE__*/_react.default.createElement(_uiKit.ActionPopup, {
        popupBtn: /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "options",
          color: "regent"
        }),
        options: popupActions
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "list-item__content"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
        assetId: assetId,
        height: "100px",
        width: "100px",
        hideFileTypeIcon: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "list-item__content__details"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "list-item__content__details__name"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Link, {
        onClick: gotoVideo
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading4: true
      }, (0, _getVideoOutputName.default)(output, videoName))), output.isMaster ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "master",
        size: 20,
        color: "goldenTainoi"
      }) : null, output.onHoldDate ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        className: "list-item__content__details__name__on-hold",
        name: "alert",
        size: 20,
        color: "thunderBird",
        tooltipId: "toolId-".concat(output.outputId),
        tooltipLabel: "Video on hold: ".concat(output.onHoldReason)
      }) : null), /*#__PURE__*/_react.default.createElement(_TrafficListItemDueDate.default, {
        dueDate: dueDate,
        hoursLeft: hoursLeft,
        outputStatus: status.name
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "list-item__content__details__info"
      }, organisation ? /*#__PURE__*/_react.default.createElement(_components.ProfileCard, {
        className: "list-item__content__details__info__organisation",
        name: organisation.name,
        imageUrl: organisation.imageUrl
      }) : null, owner ? /*#__PURE__*/_react.default.createElement(_components.ProfileCard, {
        name: (0, _getUserFullName.default)(owner),
        imageUrl: owner.imageUrl,
        user: owner,
        orgAlias: organisation && organisation.alias
      }) : null, !isDraft ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "list-item__content__details__info__editor-wrapper",
        onClick: this.stopPropagation,
        onKeyDown: this.stopPropagation,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
        id: "video-editor",
        className: "list-item__content__details__info__editor",
        placeholder: "Select video editor",
        onChange: this.handleEditorChange,
        defaultValue: this.getEditorOption(editor),
        options: editors.map(this.getEditorOption),
        isSearchable: true
      })), /*#__PURE__*/_react.default.createElement("span", {
        onClick: this.stopPropagation,
        onKeyDown: this.stopPropagation,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement(_components.DifficultyDropdown, {
        defaultValue: difficulty,
        updateDifficulty: this.handleDifficultyChange
      }))) : null))), this.renderAddons(appliedAddons));
    }
  }]);

  return TrafficListItem;
}(_react.Component);

exports.default = TrafficListItem;